export const Star = () => (
  <svg width="12" height="13" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M4.82597 12.5043L5.03156 7.93807L1.17944 10.416L0 8.36007L4.09017 6.2717L0 4.18334L1.17944 2.12743L5.03156 4.60534L4.82597 0.0390625H7.17403L6.96844 4.60534L10.8206 2.12743L12 4.18334L7.90983 6.2717L12 8.36007L10.8206 10.416L6.96844 7.93807L7.17403 12.5043H4.82597Z"
      fill="#2F79E8"
    />
  </svg>
);
export default Star;
